<app-office-form
  action="{{ 'new' | translate }}"
  (close)="closeForm($event)">
</app-office-form>
